import {logger} from "@main/helpers/logger";
import {getSiblings} from "@main/helpers/dom";
import axios from "@main/axios";
import partnerJob from "@partials/partner-job.handlebars";

const MAX_VISIBLE_NUM_IN_PAGINATION = 5;

/** Класс модального окна "Требования к должности". */
class PartnerVacancies {
    page = 1

    pageCount

    pagination = null

    searchValue
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.url = this.el.dataset.url;
        this.form = this.el.querySelector(".js-vacancies-form");
        this.searchInput = this.form.querySelector(".js-search-input");
        this.list = this.el.querySelector(".js-vacancies-list");

        if (this.list.nextElementSibling.classList.contains("js-pagination")) {
            this.pagination = this.list.nextElementSibling;
            this.pageCount = this.el.dataset.initPages;
            
        }
        this.createVacanciesList();
        this.bindEventListeners();
        
    }

    onMounted = async () => {
        this.createPagination();
    }

    bindEventListeners() {
        document.addEventListener("maponload", this.onMounted);

        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.searchValue = this.getSearchInputValue();
            this.createVacanciesList();
        })

        this.updatePageNumber();
    }

    /**
     * Получение значения поисковой строки.
     * 
     * @returns {string} Значение поисковой строки.
     */
    getSearchInputValue() {
        return this.searchInput.value.trim();
    }

    /**
     * Получение списка вакансий.
     * 
     * @returns {Promise}
     */
    getPartnerVacancies = async () => {
        try {
            const {data} = await axios({
                url: this.url,
                method: "GET",
                params: {
                    page: this.page,
                    searchValue: this.searchValue
                }
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    } 

    /**
     * Создание карточек вакансий.
     * 
     * @param {Object} data Данные со списком вакансий.
     * @returns {void}
     */
    createCardsVacancies(data) {
        const cardVacancy = {
            vacancy: {
                id: data.id,
                name: data.name,
                text: data.text,
            }
        }

        const vacancy = partnerJob(cardVacancy);
        this.list.insertAdjacentHTML("beforeend", vacancy);
    }

    /**
     * Создание списка вакансий при загрузке страницы
     * 
     * @param {Object} data Список вакансий
     * @returns {void}
     */
    createVacanciesList = async () => {
        const response = await this.getPartnerVacancies();
        const vacancies = response.data.vacancies;
        this.pageCount = response.data.pageCount;
        this.list.innerHTML = "";
        vacancies.forEach((el) => {
            this.createCardsVacancies(el);
        });
    }

    // создание пагинации
    createPagination = async () => {
        if (!this.pagination) {
            return;
        }

        for (let i = 1; i <= this.pageCount; i++) {
            const paginationLink = document.createElement("a");
            paginationLink.className = "pagination__link js-pagination-link";
            paginationLink.innerHTML = i;
            paginationLink.setAttribute("data-page", i);

            if (i < MAX_VISIBLE_NUM_IN_PAGINATION + 1) {
                this.pagination.insertAdjacentElement("beforeend", paginationLink);
            }            
        }

        // Добавляем кнопку "В начало"
        const buttonGoToStart = document.createElement("a");
        buttonGoToStart.className = "pagination__link pagination__link--nav js-pagination-first";
        buttonGoToStart.innerHTML = "в начало";
        this.pagination.insertAdjacentElement("afterbegin", buttonGoToStart);

        if (this.page == 1) {
            buttonGoToStart.setAttribute("disabled", "disabled");
            buttonGoToStart.nextElementSibling.classList.add("pagination__link--active");
        } 

        // добавляем кнопку "Дальше"
        const buttonMoveOn = document.createElement("a");
        buttonMoveOn.className = "pagination__link pagination__link--nav js-pagination-farther";
        buttonMoveOn.innerHTML = "дальше";
        this.pagination.insertAdjacentElement("beforeend", buttonMoveOn);

        if (this.pageCount == 1) {
            buttonMoveOn.setAttribute("disabled", "disabled");
        }

        if (this.pageCount > MAX_VISIBLE_NUM_IN_PAGINATION) {
            this.updatePagination(this.page, this.pageCount);
        }
    }

    // клик на "Дальше"
    clickToNextPage(target, numberOfPages) {
        this.page += 1;
        this.year = this.selectedYear;
        this.month = this.selectedMonth;

        if (this.page <= numberOfPages) {
            this.goToPage(this.page, numberOfPages);
            this.createVacanciesList();
        } else {
            target.setAttribute("disabled", "disabled");
        }
    }

    // клик на кнопку "В начало"
    clickButtonToStartPage(numberOfPages) {
        this.page = 1;

        this.goToPage(this.page, numberOfPages);
        this.createVacanciesList();
    }

    // обновить номер страницы
    updatePageNumber() {
        if (!this.pagination) {
            return;
        }

        this.pagination.addEventListener("click", async (e) => {
            const target = e.target;
            e.preventDefault();

            // клик на номер страницы
            if (target.classList.contains("js-pagination-link")) {                
                // получаем номер страницы
                const numberPage = Number(target.getAttribute("data-page"));

                this.page = numberPage;
                this.year = this.selectedYear;
                this.month = this.selectedMonth;

                this.goToPage(this.page, this.pageCount);

                this.createVacanciesList();
 
                this.scrollToTopPaginationList();
            }

            // клик на "Далее"
            if (target.classList.contains("js-pagination-farther")) {
                this.clickToNextPage(target, this.pageCount);
                this.scrollToTopPaginationList();
            }

            // клик на "В начало"
            if (target.classList.contains("js-pagination-first")) {
                this.clickButtonToStartPage(this.pageCount);
                this.scrollToTopPaginationList();
            }
        })
    }

    /**
     * Прокрутить к началу списка с публикациями при переходе на страницу. 
     * 
     * @returns {void}
     */
    scrollToTopPaginationList() {
        const vacanciesList = this.pagination.previousElementSibling;
        const rectTop = vacanciesList.getBoundingClientRect().top + window.pageYOffset; 
        window.scrollTo({
            top: rectTop,
            behavior: "smooth"
        });
    }

    // перейти к странице
    goToPage(number, numberOfPages) {
        if (!this.pagination) {
            return;
        }

        this.page = number;

        const paginationLinks = [...this.pagination.getElementsByClassName("js-pagination-link")];

        // Переключать disabled у кнопки "В начало"
        const buttonGoToStart = this.pagination.getElementsByClassName("js-pagination-first");

        if (this.page !== 1 && buttonGoToStart[0].hasAttribute("disabled")) {
            buttonGoToStart[0].removeAttribute("disabled");
        } else if (this.page == 1) {
            buttonGoToStart[0].setAttribute("disabled", "disabled");
        }

        // Переключать disabled у кнопки "Далее"
        const buttonGoToNext = this.pagination.getElementsByClassName("js-pagination-farther");

        if (this.page < numberOfPages && buttonGoToNext[0].hasAttribute("disabled")) {
            buttonGoToNext[0].removeAttribute("disabled");
        } else if (this.page == numberOfPages) {
            buttonGoToNext[0].setAttribute("disabled", "disabled");
        }

        this.updatePagination(this.page, numberOfPages);

        const selectedPage = paginationLinks.filter( (item) => {              
            return +(item.getAttribute("data-page")) === this.page;
        })

        selectedPage.forEach(page => {
            if (!page.classList.contains("pagination__link--active")) {
                page.classList.add("pagination__link--active");

                const siblings = getSiblings(page);
                siblings.forEach(el => {
                    if (el.classList.contains("pagination__link--active")) {
                        el.classList.remove("pagination__link--active");
                    }
                })
            }
        })
    }

    // обновить пагинацию
    updatePagination(currentPage, maxAmount) {
        const paginationLinks = [...this.pagination.querySelectorAll(".js-pagination-link")];
        let newFirstNumberPages;

        if (maxAmount <= MAX_VISIBLE_NUM_IN_PAGINATION) {
            paginationLinks.forEach((link) => { 
                if (link.dataset.page > maxAmount) {
                    link.classList.add("hidden");
                } else {
                    link.classList.remove("hidden");
                }         
            });

            return;
        }

        if (currentPage > Math.ceil(MAX_VISIBLE_NUM_IN_PAGINATION / 2) && 
            currentPage < (maxAmount - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2))) {            
            newFirstNumberPages = currentPage - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2);
        }

        if (currentPage <= Math.ceil(MAX_VISIBLE_NUM_IN_PAGINATION / 2)) {
            newFirstNumberPages = 1;
        }

        if (currentPage >= (maxAmount - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2))) {
            newFirstNumberPages = maxAmount - MAX_VISIBLE_NUM_IN_PAGINATION + 1;
        }
        
        paginationLinks.forEach((link) => {
            if (link.classList.contains("hidden")) {
                link.classList.remove("hidden")
            }
            link.innerHTML = newFirstNumberPages;
            link.setAttribute("data-page", newFirstNumberPages);
            newFirstNumberPages++;            
        });
    }

}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-vacancies-block").forEach((item) => new PartnerVacancies(item));
});
